
import React from 'react';
import { Switch, Route } from 'react-router-dom';
import "./Content.css";
import Dashboard from "../Domain/Dashboard/Dashboard";
import FileTraceRouter from "../Domain/FileTrace/FileTraceRouter";
import HotelBaseCompliance from "../Domain/Compliance/HotelBase/HotelBaseCompliance";
import QMSErrorHandle from '../auxil/QMSErrorHandle'
import Logout from '../auxil/Logout';
import LogoutAll from '../auxil/LogoutAll.js';
import { Layout } from 'antd';
import 'antd/dist/antd.css';
const { Content } = Layout;

class QMSContent extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;

    }

    render() {
        var notFoundError = {
            display:true,
            err: true,
            errCode: '404',
            errType: 'pageErr',
            errMsg: 'No page Found'
        }
        return (
            <Content 
            // style={{minHeight : "100vh"}}
            >
                <Switch>
                    {/* <Route exact path="/" component={({ match }) =>
                        <Dashboard
                            match={match}
                            accessType={this.props.accessType}
                            user={this.props.user} />}
                    /> */}
                    <Route exact path={["/", "/filetrace", "/filetrace/:eventDateTime/:entityId/:projectId",
                        "/filetrace/:eventDateTime/:entityId/:projectId/:pms"]} component={({ match }) =>
                        <FileTraceRouter
                            match={match}
                            user={this.props.user}
                            accessType={this.props.accessType}
                            permitExtraDetails={this.props.permitExtraDetails}
                            solutions={this.props.solutions}
                        />
                    } />
                    <Route exact path={["/qms-compliance-hotel-base"]} component={({ match }) =>
                        <HotelBaseCompliance
                            match={match}
                            user={this.props.user}
                            accessType={this.props.accessType}
                            solutions={this.props.solutions}
                            compliancePermissions={this.props.compliancePermissions}
                            userId={this.props.userId}
                            userEmail={this.props.userEmail}
                        />}
                    />
                    <Route exact path="/logout" component={({ match }) =>
                        <Logout
                            match={match}
                            user={this.props.user}
                        />
                    } />
                    <Route exact path="/logoutall" component={({ match }) =>
                        <LogoutAll
                            match={match}
                            user={this.props.user}
                        />
                    } />
                    <Route component={ () =>
                        <QMSErrorHandle errordetails={notFoundError} />}
                    />
                </Switch>
            </Content>
        );
    }
}

export default QMSContent;